import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";

import QualitativeRatingForm from "../../Components/QualitativeRatingForm";
import { GET } from "../../utils/helper";

const QualitativeRating = ({ showLook, isManager }) => {
  
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const employeeAttribute = location?.state?.employeeAttribute;
  const employee_id = location?.state?.employee_id;

  const history = useHistory();

  const [employeeRates, setEmployeeRates] = useState(null);

  useEffect(() => {
    const getList = async () => {
      try {
        setLoading(true);
        const result = await GET(
          `getAttributeRatingsGrouped?employee_id=${employee_id}`
        );
        setLoading(false);
        if (result?.body?.data) {
          setEmployeeRates(result?.body?.data);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    getList();
  }, []);

  return (
    <div className="min-height-60vh qualitative-rating-wrapper">
      <div className="container">
        {showLook && (
          <p className="form-control Goal">{employeeAttribute?.employeeName}</p>
        )}
        <br />
        {!loading ? (
          employeeRates && typeof employeeRates === "object" ? (
            Object.entries(employeeRates).map(([key, items]) => {
              return (<QualitativeRatingForm
                ratingsData={items}
                qualitativeTargetName={
                  items.length && items[0]?.attribute?.name
                }
                attributeId={items.length && items[0]?.attribute_id}
                id={items.length && items[0]?.id}
                readOnly={showLook}
                isManager={isManager}
                isUpdate={true}
                onSuccess={() => history.push("/dashboard")}
              />)
            })) : (
            <div className="heding  heading-color">
              <h4>qualitative target not found</h4>
            </div>
          )) : (
          <div
            style={{ marginBottom: "4rem" }}
            class="spinner-border text-primary"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.globalReducer.loading,
    errorMsg: state.loginReducer.errorMsg,
    showLook: state.globalReducer.showLook,
    isManager: state.loginReducer.loginData?.is_manager,
  };
};

const mapDispatch = (dispatchEvent) => ({});

export default connect(mapStateToProps, mapDispatch)(QualitativeRating);
